import React from 'react';
import { useSelector } from 'react-redux';
import { State } from 'reducers';
import { HasUrlSlug, getBuildingIdByUrlSlug } from 'selectors/buildingsSelectors';
import { useParams } from 'util/reactRouterHooks';
import { BuildingEcsForm } from '../buildingEcsForm/BuildingEcsForm';
import { ErrorMessage, SuccessMessage } from 'ui/shared/messages';
import { useTranslation } from 'react-i18next';
import { useEcsBuilding } from 'hooks/useEcsBuilding/useEcsBuilding';

export const BuildingEcsPage = () => {
    const { t } = useTranslation();
    const params = useParams<HasUrlSlug>();

    const buildingId = useSelector((state: State) => getBuildingIdByUrlSlug(state, params));

    const {
        //isEcsEnabled,
        //isSubscriptionExpired,
        //daysUntilExpiry,
        ecsBuilding,
        isLoadingEcsBuilding,
        isSavingEcsBuilding,
        saveEcsBuilding,
        ecsErrorMessage,
        successVisible,
        hideSuccess,
    } = useEcsBuilding(buildingId);

    return (
        <div id="building-ecs-page" className="page">
            { !isLoadingEcsBuilding && ecsErrorMessage &&
                <ErrorMessage
                    message={ ecsErrorMessage }
                />
            }
            { buildingId &&
                <BuildingEcsForm
                    buildingId={ buildingId }
                    data={ ecsBuilding || null }
                    isLoading={ isLoadingEcsBuilding }
                    isSaving={ isSavingEcsBuilding }
                    onClickSave={ saveEcsBuilding }
                />
            }
            { successVisible &&
                <SuccessMessage
                    message={ t('SAVED_MESSAGE') }
                    onClick={ hideSuccess }
                />
            }
        </div>
    );
};
